import angular from 'angular';
import CommonService from "./common-service";

let Common = angular
    .module('Common', [])
    .service('CommonService', CommonService);

export default Common;

